import React from "react";
import { Button, Table } from "react-bootstrap";
import ActionItemsGrid from "../../tasks/ActionItemsGrid";
import Barschart from "../../barschart/Barschart";
import './budgetoverviewtab.css'

const Budgetoverviewtab: React.FC = () => {
    return (
        <>
            <div className="files_grid_four mby_24">
                <ActionItemsGrid />
            </div>
            <div className="common_card">
                <div className="top top_bar_flx mby_12">
                    <div className="top_bar_tittle">
                        <h2>By Waiver Type — Billable • Billed • Paid</h2>
                    </div>
                    <div className="top_right_flx">
                        <Button variant="light" className="btn_sm">Export by Waiver</Button>
                    </div>
                </div>
                <Barschart />
                <Table responsive className="common_table">
                    <thead>
                        <tr>
                            <th>Waiver</th>
                            <th>Billable</th>
                            <th>Billed</th>
                            <th>Paid</th>
                            <th>Realization %</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>OCID</td>
                            <td>$10000</td>
                            <td>$10000</td>
                            <td>$10000</td>
                            <td>88%</td>
                        </tr>
                        <tr>
                            <td>OCID</td>
                            <td>$10000</td>
                            <td>$10000</td>
                            <td>$10000</td>
                            <td>88%</td>
                        </tr>
                        <tr>
                            <td>OCID</td>
                            <td>$10000</td>
                            <td>$10000</td>
                            <td>$10000</td>
                            <td>88%</td>
                        </tr>
                        <tr>
                            <td>OCID</td>
                            <td>$10000</td>
                            <td>$10000</td>
                            <td>$10000</td>
                            <td>88%</td>
                        </tr>
                    </tbody>
                </Table>

            </div>
        </>
    );
};

export default Budgetoverviewtab;
